export const mapStatusToColor:{[key:string]: string} = {
    'PENDING': 'warning',
    'PROCESSING': 'primary',
    'COMPLETED': 'info',
    'DELIVERED': 'success',
    'CANCELLED': 'danger',
    'FAILED': 'danger'
}